module.exports = __webpack_public_path__ + "img/read_more.f59c8fee.svg";